import { IGroup } from '../shared/interfaces/IGroup';
import http from '../shared/HttpCommon';

class GroupService {
  async getGroups(): Promise<IGroup[]> {
    try {
      const { data } = await http.get('/monitoring/groups');
      return data || [];
    } catch (error) {
      console.error('Failed to fetch groups:', error);
      throw error;
    }
  }

  async createGroup(groupData: {
    name: string;
    color: string;
    monitoringEntryIds: string[];
  }): Promise<IGroup> {
    try {
      const { data } = await http.post('/monitoring/groups', groupData);
      return data;
    } catch (error) {
      console.error('Failed to create group:', error);
      throw error;
    }
  }

  async updateGroup(
    id: string,
    groupData: {
      name?: string;
      color?: string;
      monitoringEntryIds?: string[];
    }
  ): Promise<IGroup> {
    try {
      const { data } = await http.patch(`/monitoring/groups/${id}`, groupData);
      return data;
    } catch (error) {
      console.error('Failed to update group:', error);
      throw error;
    }
  }

  async deleteGroup(id: string): Promise<{ success: boolean }> {
    try {
      await http.delete(`/monitoring/groups/${id}`);
      return { success: true };
    } catch (error) {
      console.error('Failed to delete group:', error);
      throw error;
    }
  }
}

export default new GroupService();
